import React from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import { CrossButton, Icon, RegularTooltip } from "@sportal/cdk";

import { useIntlTranslate } from "../../../hooks";
import { Button } from "../../button/Button";
import { ButtonLink } from "../../buttonLink/ButtonLink";
import { hideSpsonPanel } from "../../../store/banners";
import { generateDeeplink } from "../../deeplinkDialog/deeplinkDialog.actions";

import "./SpsonPanel.scss";

export const SpsonPanel = () => {
  const dispatch = useDispatch();
  const translate = useIntlTranslate();

  function handleGenerateLinkClick() {
    dispatch(generateDeeplink());
  }

  return (
    <div className={"spson-panel"}>
      <div className={"spson-panel__main"}>
        <div className={"spson-panel__header"}>
          <Icon icon={"fa-solid fa-shield-check"} />
          <span>
            <FormattedMessage id={"sps_client"} />
          </span>
        </div>
        <p className={"spson-panel__info"}>
          <FormattedMessage id={"sps_panel_info"} />
        </p>
      </div>
      <div className={"spson-panel__actions"}>
        <ButtonLink
          className={"manage-devices spson-panel__action-button"}
          size={"medium"}
          color={"primary"}
          variant={"outlined"}
          to={"/settings/devices"}
          aria-label={translate("aria_link_to_page", {
            linkText: translate("manage_devices"),
            pageName: translate("devices"),
          })}
        >
          <FormattedMessage id={"manage_devices"} />
        </ButtonLink>
        <Button
          size={"medium"}
          color={"primary"}
          className={"spson-panel__action-button"}
          aria-label={translate("aria_sps_button_generate_link")}
          onClick={handleGenerateLinkClick}
        >
          <FormattedMessage id={"generate_link"} />
        </Button>
      </div>
      <div className={"spson-panel__close"}>
        <RegularTooltip
          placement={"top-end"}
          content={<FormattedMessage id={"sps_close_tooltip"} />}
        >
          <CrossButton
            onClick={() => dispatch(hideSpsonPanel())}
            size={"small"}
            aria-label={translate("aria_sps_close_tooltip")}
          />
        </RegularTooltip>
      </div>
    </div>
  );
};
